import DemeritEducationReservationForm from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationForm';

interface DemeritEducationReservationPageProps {
  vin: string;
}

function DemeritEducationReservationPage({vin}: DemeritEducationReservationPageProps) {
  return <DemeritEducationReservationForm vin={vin} />;
}

export default DemeritEducationReservationPage;
